module.exports = __webpack_public_path__ + "img/checklist_inverted.7eefad0c.svg";